import { tabPanelStyles as fastTabPanelStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationTabPanelStyles = (context, definition) => css `
  ${fastTabPanelStyles(context, definition)}
`;
